<cs-image
    [src]="optimisedSrc()"
    [imageStyle]="computedStyle()"
    [alt]="alt()"
    [priority]="priority()"
    [isError]="isImageLoadError()"
    (loaded)="onLoad()"
    (loadedFailed)="onLoadError()" />
